export default __webpack_public_path__ + "static/media/Titel_image_Ruimte.3d685998.jpg";